export enum AuthLocalStorageKeys {
  TOKEN = '@auth/token',
}